var _jsxFileName = "/codebuild/output/src454737571/src/bitbucket.org/newyuinc/adc-polaris-web/src/index.tsx";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.aggregate-error.js";
import "core-js/modules/es.aggregate-error.cause.js";
import "core-js/modules/es.array.at.js";
import "core-js/modules/es.array.find-last.js";
import "core-js/modules/es.array.find-last-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.has-own.js";
import "core-js/modules/es.promise.any.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.string.at-alternative.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.immediate.js";
import "core-js/modules/web.structured-clone.js";
// this (wdyr) MUST be loaded first in order for it to do it's magic
// import './wdyr';
// This should be changed by babel to only the imports that are needed by our target
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { LoadingModal } from '@adc/parallax-component-library';
import { InitializationErrorPage, MainContainer, Providers } from 'Components/utility';
import { getApp, setInitialApiUrl } from 'Utilities/dataHelpers';
import { getEnvConfig } from 'Utilities/envConfig';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { createStore } from 'Utilities/store';
import App from './App';
import './index.css';
// Import the services via the index file in that folder
import './services';

// if (process.env.NODE_ENV !== 'production') {
//   import('./dev');
//   App.whyDidYouRender = true;
// }

let store;
let root;

// This is the starting point of our app launch life-cycle
const init = () => {
  const container = document.getElementById('app');

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  root = createRoot(container);
  store = createStore();
  renderLoading();
  getEnvConfig().then(config => {
    log.init(config.logLevel);
    if (config.mock) {
      mediator.once('MOCK:setup:intialized', () => initializeStore(config));

      // This import would allow you to have the mock code ready to go
      import('./services/mock');
    } else {
      initializeStore(config);
      if (!config.production) {
        import('./utilities/testHelper');
      }
    }
  }).catch(err => {
    log.error('failed to get the environment config: ' + err);
    renderError();
  });
};
const renderLoading = () => {
  window.setTimeout(() => {
    root.render(/*#__PURE__*/React.createElement(Providers, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(MainContainer, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(LoadingModal, {
      "aria-label": "Loading",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 11
      }
    }))));
  }, 0);
};

// Renders our UnexpectedError display and minimally bootstraps i18n
const renderError = () => {
  // since there was an error, need to initialize services anyway
  mediator.publish('init:i18n');
  window.setTimeout(() => {
    root.render(/*#__PURE__*/React.createElement(InitializationErrorPage, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 17
      }
    }));
  }, 0);
};

// Finally render our React trees
const renderApp = () => {
  // This timeout is added to try and deal with the translations not being ready when the site loads (only
  // seen as an issue in IE, of course). if we think we're still seeing that issue then remove this timeout
  // when a different solution is found
  window.setTimeout(() => {
    try {
      root.render(/*#__PURE__*/React.createElement(Provider, {
        store: store,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 96,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(App, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97,
          columnNumber: 11
        }
      })));
    } catch (e) {
      log.error(e);
      renderError();
    }
  }, 0);
};

// Add code here that you would like to do when you have the env config ready
// This is likely going to be lagic to attempt getting an existing session
// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
const initializeStore = envConfig => {
  setInitialApiUrl(envConfig, getApp());
  store = createStore();
  mediator.publish('store:created');
};

// Begin
init();

// Services that need to publish that they are ready
const appReady = {
  i18n: false,
  router: false

  // state would be useful to track if redux store is ready
  // state: false,
};

// Listens for all services to be complete so that we have everything we need when we mount React
const readySub = mediator.subscribe('app:ready', ready => {
  Object.assign(appReady, ready);
  const done = Object.values(appReady).every(value => !!value);

  // If the router is ready, we can initialize i18n because the config is fetched during routing
  if (ready.router) {
    mediator.publish('init:i18n');
  }
  if (done) {
    mediator.publish('app:mounted');
    mediator.remove('app:ready', readySub.id);
  }
});

// This block will only be called when the page is fully ready
// right now that means that our router service has spun up and done its initial work (redirecting if necessary)
// and the nav service has updated the store to reflect that.
// THEN 'app:ready' is published. otherwise the components may erroneously read the location information
// from the store (for example, the component may try reading it before the nav service has updated it, this
// was a problem fairly consistent with IE)
mediator.once('app:mounted', renderApp);